import Colors from 'assets/Colors';
import Funcs from 'common/helpers/Funcs';
import AppConst from 'consts/AppConst';
import UIConst from 'consts/UIConst';
import React from 'react';
import { ActivityIndicator, StyleSheet, TextInput, View } from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import BaseButton from './BaseButton';

class Input extends React.Component {
  constructor(props) {
    super(props);
    const { defaultValue, value, keyboardType, isNumber, editable } = props;
    let value1 = defaultValue ? '' + this.formatText(defaultValue) : '';
    if (value) value1 = this.formatText(value);
    this.state = { value: value1, editable };
    this.keyboardType = !keyboardType ? (isNumber ? (AppConst.IS_IOS ? 'numbers-and-punctuation' : 'numeric') : 'default') : keyboardType;
    if (!this.keyboardType) this.keyboardType = 'default';
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.value !== nextProps.value) {
      this.setText(nextProps.value);
    }
    if (this.props.editable !== nextProps.editable) {
      this.setState({ editable: nextProps.editable });
    }
    if (this.props.defaultValue !== nextProps.defaultValue) {
      this.setText(nextProps.defaultValue);
    }
    return this.state !== nextState;
  }

  onChangeText = (value) => {
    let { onChangeText } = this.props;
    this.setText(value);
    if (onChangeText) onChangeText(value);
  };

  getText = () => {
    let { value } = this.state;
    let { isNumber } = this.props;
    if (isNumber) {
      value = value
        .toString()
        .split(',')
        .join('');
    } else if (!value) value = '';
    return value?.trim();
  };

  setText = (value, callback) => {
    const newValue = this.formatText(value);
    if (this.state.value !== newValue) this.setState({ value: newValue }, callback);
  };

  formatText = (value = '') => {
    if (!this.props.isNumber || !value || value === '-') return value;
    if (value === 'undefined' || value === 'null') return '';
    value = value
      .toString()
      .split(',')
      .join('')
      .replace(/^(-?)0+(?=\d)/, '$1');
    if (isNaN(value)) value = 0;
    value = Funcs.formatNumber(value, ',');
    return value;
  };

  render() {
    const { defaultValue, inputStyle = {}, fontSize = UIConst.FONT_SIZE, placeholder, multiline, textAlign } = this.props;
    const { maxLength, secureTextEntry, returnKeyType, onBlur, textContentType } = this.props;
    const { value, editable } = this.state;
    const multilineStyle = multiline ? { height: '100%' } : {};
    return (
      <TextInput
        textAlign={textAlign}
        textContentType={textContentType}
        onBlur={onBlur}
        secureTextEntry={secureTextEntry}
        returnKeyType={returnKeyType}
        editable={editable}
        maxLength={maxLength}
        multiline={multiline}
        placeholder={placeholder}
        value={value + ''}
        ref={(input) => (this.TextInput = input)}
        defaultValue={defaultValue ? defaultValue + '' : ''}
        onChangeText={this.onChangeText}
        keyboardType={this.keyboardType}
        textAlignVertical={multiline ? 'top' : 'center'}
        style={[styles.textInputStyle, { color: Colors.text, fontSize }, multilineStyle, inputStyle]}
        placeholderTextColor={Colors.placeholder}
      />
    );
  }
}

export default class BaseInput extends React.PureComponent {
  state = {};

  focus = () => {
    this.input.TextInput.focus();
  };

  blur = () => {
    this.input.TextInput.blur();
  };

  reset = () => {
    this.input.setState({ value: '' });
  };

  getText = () => {
    return this.input.getText();
  };

  setText = (value, callback) => {
    this.input.setText(value, callback);
  };

  onChangeText = (value) => {
    if (this.currentValue === value) return;
    this.currentValue = value;
    let { onChangeText, showClear } = this.props;
    if (onChangeText) onChangeText(value);
    if (showClear) this.setState({ canShowClear: value?.toString()?.length > 0 });
  };

  onPressClear = () => {
    this.input.onChangeText('');
  };

  render() {
    const { showClear, searching, style, childComponent, hasSearchIcon, editable } = this.props;
    const { canShowClear } = this.state;
    return (
      <View
        style={[style, { alignItems: 'center', flexDirection: 'row', paddingRight: UIConst.SCALE * 5 }, editable ? {} : { backgroundColor: style?.backgroundColor || Colors.box }]}>
        {!!hasSearchIcon && <MaterialIcons name={'search'} size={UIConst.SCALE * 18} color={Colors.text} style={{ marginLeft: UIConst.SCALE * 6, opacity: 0.5 }} />}
        <Input {...this.props} ref={(input) => (this.input = input)} onChangeText={this.onChangeText} />
        {!!searching && <ActivityIndicator size={'small'} style={{}} />}
        {!!showClear && !searching && canShowClear && (
          <BaseButton style={{}} onPress={this.onPressClear}>
            <MaterialCommunityIcons name={'close-circle'} size={UIConst.SCALE * 18} color={Colors.text} />
          </BaseButton>
        )}
        {childComponent}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  textInputStyle: {
    flex: 1,
    fontSize: UIConst.FONT_SIZE,
    paddingVertical: UIConst.SCALE * 6,
    paddingHorizontal: UIConst.SCALE * 7
  }
});
